'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var prefix = 'fal';
var iconName = 'left';
var width = 448;
var height = 512;
var aliases = ["arrow-alt-left"];
var unicode = 'f355';
var svgPathData = 'M32 258.3l0-4.6c0-4.4 1.8-8.6 5-11.6L186.8 99.5c2.3-2.2 5.4-3.5 8.7-3.5c6.9 0 12.6 5.6 12.6 12.6l0 83.4c0 8.8 7.2 16 16 16l176 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-176 0c-8.8 0-16 7.2-16 16l0 83.4c0 6.9-5.6 12.6-12.6 12.6c-3.2 0-6.3-1.2-8.7-3.5L37 269.9c-3.2-3-5-7.2-5-11.6zM195.4 64C184 64 173 68.4 164.7 76.3L14.9 219C5.4 228 0 240.6 0 253.7l0 4.6C0 271.4 5.4 284 14.9 293L164.7 435.7C173 443.6 184 448 195.4 448c24.6 0 44.6-20 44.6-44.6l0-67.4 160 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-160 0 0-67.4C240 84 220 64 195.4 64z';
exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, aliases, unicode, svgPathData]
};
exports.faLeft = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;